export interface ImageSearchResultItem {
  id: string;
  name: string;
  sku: string;
  category: string;
  image_url: string;
  capacity: string;
  material: string;
  shape: string | null;
  neck_size: string | null;
  availability_display: string;
  availability_badge_type: string;
  moq_display: string;
  lead_time_display: string;
  display_price: number;
  display_currency: string;
  price_unit: string;
  price_note: string;
  availability_status: string;
  similarity: number;
}

export interface ImageSearchResultJson {
  search_type: string;
  query_label: string;
  total: number;
  status_message: string;
  items: ImageSearchResultItem[];
}

export const mockImageSearchResults: ImageSearchResultJson = {
  search_type: "image",
  query_label: "Uploaded image",
  total: 8,
  status_message: "8 similar products found from your uploaded image.",
  items: [
    {
      id: "prod-search-001",
      name: "Airless Pump Bottle 50ml",
      sku: "AB-50-WH",
      category: "Airless",
      image_url: "",
      capacity: "50ml",
      material: "PET",
      shape: null,
      neck_size: null,
      availability_display: "Available",
      availability_badge_type: "success",
      moq_display: "MOQ 5,000",
      lead_time_display: "30-45 days",
      display_price: 0.42,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Final quote will be confirmed after admin review.",
      availability_status: "available",
      similarity: 0.94,
    },
    {
      id: "prod-search-002",
      name: "Premium Glass Dropper Bottle 30ml",
      sku: "GD-30-AM",
      category: "Dropper",
      image_url: "",
      capacity: "30ml",
      material: "Glass",
      shape: null,
      neck_size: null,
      availability_display: "Available",
      availability_badge_type: "success",
      moq_display: "MOQ 3,000",
      lead_time_display: "25-35 days",
      display_price: 0.65,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Final quote will be confirmed after admin review.",
      availability_status: "available",
      similarity: 0.89,
    },
    {
      id: "prod-search-003",
      name: "Matte Finish Lotion Pump Bottle 100ml",
      sku: "LP-100-MT",
      category: "Lotion Pump",
      image_url: "",
      capacity: "100ml",
      material: "PET",
      shape: null,
      neck_size: null,
      availability_display: "Limited Stock",
      availability_badge_type: "warning",
      moq_display: "MOQ 2,000",
      lead_time_display: "20-30 days",
      display_price: 0.55,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Limited stock available. Contact for current inventory.",
      availability_status: "limited_stock",
      similarity: 0.85,
    },
    {
      id: "prod-search-004",
      name: "Cream Jar 50g with Inner Lid",
      sku: "CJ-50-WH",
      category: "Jar",
      image_url: "",
      capacity: "50g",
      material: "PP",
      shape: null,
      neck_size: null,
      availability_display: "Available",
      availability_badge_type: "success",
      moq_display: "MOQ 5,000",
      lead_time_display: "30-40 days",
      display_price: 0.38,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Final quote will be confirmed after admin review.",
      availability_status: "available",
      similarity: 0.81,
    },
    {
      id: "prod-search-005",
      name: "Transparent PET Spray Bottle 60ml",
      sku: "SP-60-TR",
      category: "Spray",
      image_url: "",
      capacity: "60ml",
      material: "PET",
      shape: null,
      neck_size: null,
      availability_display: "Available",
      availability_badge_type: "success",
      moq_display: "MOQ 5,000",
      lead_time_display: "25-35 days",
      display_price: 0.48,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Final quote will be confirmed after admin review.",
      availability_status: "available",
      similarity: 0.78,
    },
    {
      id: "prod-search-006",
      name: "Frosted Glass Serum Bottle 15ml",
      sku: "GS-15-FR",
      category: "Serum",
      image_url: "",
      capacity: "15ml",
      material: "Glass",
      shape: null,
      neck_size: null,
      availability_display: "Made to Order",
      availability_badge_type: "info",
      moq_display: "MOQ 1,000",
      lead_time_display: "35-50 days",
      display_price: 0.85,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Made to order. Minimum lead time applies.",
      availability_status: "made_to_order",
      similarity: 0.76,
    },
    {
      id: "prod-search-007",
      name: "Dual Chamber Airless Bottle 30ml",
      sku: "DC-30-WH",
      category: "Airless",
      image_url: "",
      capacity: "30ml",
      material: "PET",
      shape: null,
      neck_size: null,
      availability_display: "Available",
      availability_badge_type: "success",
      moq_display: "MOQ 10,000",
      lead_time_display: "40-55 days",
      display_price: 1.20,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Final quote will be confirmed after admin review.",
      availability_status: "available",
      similarity: 0.72,
    },
    {
      id: "prod-search-008",
      name: "Compact Powder Case 10g with Mirror",
      sku: "CP-10-BK",
      category: "Compact",
      image_url: "",
      capacity: "10g",
      material: "ABS",
      shape: null,
      neck_size: null,
      availability_display: "Check Availability",
      availability_badge_type: "warning",
      moq_display: "MOQ 3,000",
      lead_time_display: "30-45 days",
      display_price: 0.72,
      display_currency: "USD",
      price_unit: "per unit",
      price_note: "Please contact us for current availability.",
      availability_status: "check_availability",
      similarity: 0.68,
    },
  ],
};

export const mockEmptySearchResults: ImageSearchResultJson = {
  search_type: "image",
  query_label: "Uploaded image",
  total: 0,
  status_message: "No similar products found. Try a different image or browse our catalog.",
  items: [],
};